import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { TEMPLATE_MAP } from './useOneTimePassword';
import { simpleAction } from '../../actions/utils';
import { useDispatch } from 'react-redux';
import ErrorMessage from '../alerts/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OneTimePasswordError = ({
  isError,
  errorStatus = 'LOGIN_UNAVAILABLE',
  responseLanguageKey,
  templateLanguageKey,
  showActionButton,
  template,
  resendHandler,
  history
}) => {
  const dispatch = useDispatch();
  const returnToLogin = () => {
    dispatch(simpleAction('CLICKED_BACK_BUTTON'));
    history.push('/');
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    children: [isError ? /*#__PURE__*/_jsx(View, {
      maxInlineSize: "500px",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        error: errorStatus
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        marginBlock: "400",
        textAlign: "center",
        children: responseLanguageKey && /*#__PURE__*/_jsx(FormattedMessage, {
          message: `login.otp.${templateLanguageKey}.${responseLanguageKey}.title`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: responseLanguageKey && /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `login.otp.${templateLanguageKey}.${responseLanguageKey}.body`
          })
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: showActionButton && /*#__PURE__*/_jsx(Button, {
        use: "primary",
        marginBlockStart: "1000",
        onClick: template === TEMPLATE_MAP.DEFAULT_LOGIN ? returnToLogin : resendHandler,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: template === TEMPLATE_MAP.DEFAULT_LOGIN ? 'login.otp.loginReturn' : `login.otp.${templateLanguageKey}.expired.button`
        })
      })
    })]
  });
};
export default OneTimePasswordError;